import React, { useEffect } from 'react';
import DashboardLayout from '../components/Nav';
import VoiceCDRTable from '../components/VoiceCDRTable';

export default function VoiceCDRPage() {
  useEffect(() => {
    document.title = "CDR Logs | Voice Intelligence Portal";
  }, []);

  return (
    <DashboardLayout>
      <VoiceCDRTable />
    </DashboardLayout>
  );
}
